import React from "react";
import CohortGroupTraining from "../../componentsGeneral/componentsSuperUser/cohortGroupTraining/CohortGroupTraining";

const TrainingCohort = () => {
  return (
    <div>
      <CohortGroupTraining />
    </div>
  );
};

export default TrainingCohort;
